@if (device$ | async; as device) {
    <div class="emma-card__header">
        <div fxLayout="row" fxLayoutAlign="space-between center">
            <div>
                @if (showDeviceLink && !contextService.isKioskModeEnabled) {
                    <a [routerLink]="'/device/' + device.id">{{ device?.deviceName }}</a>
                }
                @if (!showDeviceLink || contextService.isKioskModeEnabled) {
                    <span>{{ device?.deviceName }}</span>
                }
                - {{ "FIELD." + dataType | translate }}
            </div>
            @if (editGraphViews) {
                <app-device-view-list [device]="device" [dataType]="dataType"></app-device-view-list>
            }
        </div>
    </div>

    @if (device.lastData) {
        <div class="emma-card__content">
            <small>{{ device?.lastData?.[dataType]?.timestamp | date: "medium" }}</small>
            <h2
                [ngClass]="{
                    'orange-fg': statusValue === 'warning',
                    'red-fg': statusValue === 'alarm',
                }"
            >
                {{ device?.lastData?.[dataType]?.value | number: "1.1-1" }} {{ unitLabel }}
            </h2>
            @if (showAvg5) {
                <div>
                    <span
                        [ngClass]="{
                            'text-semibold': true,
                            'orange-fg': statusAvg5 === 'warning',
                            'red-fg': statusAvg5 === 'alarm',
                        }"
                    >
                        {{ device?.dataAggregation?.[dataType]?.average | number: "1.1-1" }}
                        {{ unitLabel }}
                    </span>
                    {{ "COMPONENT.Average5" | translate }}
                </div>
            }
            @if (showAvg30 && rolling30Value !== null) {
                <div>
                    <span
                        [ngClass]="{
                            'text-semibold': true,
                            'orange-fg': statusAvg30 === 'warning',
                            'red-fg': statusAvg30 === 'alarm',
                        }"
                    >
                        {{ rolling30Value | number: "1.1-1" }} {{ unitLabel }}
                    </span>
                    {{ "COMPONENT.Average30" | translate }}
                </div>
            }
        </div>
    }

    @if (!device.lastData) {
        <div class="emma-card__content emma-card__content--center">
            <small>No data yet</small>
            <div>
                <b>
                    {{ "COMPONENT.DeviceDisconnected" | translate }}
                </b>
            </div>
        </div>
    }

    @if (device.lastData) {
        <div class="emma-card__footer-full-width">
            <highcharts-chart
                [Highcharts]="Highcharts"
                [constructorType]="chart.constructor"
                [options]="chart.options"
                [(update)]="chart.update"
                style="width: 100%; display: block"
                [callbackFunction]="chartCallback"
            ></highcharts-chart>
        </div>
    }

    @if (!device.connected && device.lastData) {
        <div class="emma-card__offline">
            {{ "COMPONENT.DeviceOffline" | translate }}
        </div>
    }
}
